module.exports = __webpack_public_path__ + "static/media/map.1fd0d458.jpg";